export default __webpack_public_path__ + "static/media/switfstrikes8.9ac23b37.png";